module.exports = __webpack_public_path__ + "media/images/discord-logo-white-9a823ca6.svg";